import { Translations } from './en';

const fr: Translations = {
  title: {
    questions: 'Questions',
    respondents: 'Répondants',
  },
  createButtonLabel: 'Ajouter des questions',
  deleteButtonLabel: 'Supprimer les questions',
  exportButtonLabel: 'Exporter',
  filtersButtonLabel: 'Filtrer',
  publishButtonLabel: 'Publier',
  publishedCount: '{{count}} publiées',
  publishedCount_one: '{{count}} publiée',
  onlineButtonLabel: 'Mettre en ligne',
  offlineButtonLabel: 'Mettre hors ligne',
  archiveButtonLabel: 'Archiver',
  respondentsHeaderTitle: 'Répondants',
  respondentHeaderTitle: 'Réponses de {{name}}',
  questionHeaderTitle: 'Question',
  notifications: {
    trainingStatusChangeSuccess: 'Statut d’entraînement modifié',
    trainingStatusChangeError: 'Échec de la modification du statut d’entraînement',
  },
  questionsTable: {
    questionId: 'ID Question',
    participantsNumber: 'Nombre de participants',
    timeAverage: 'Temps moyen',
    training: 'Entraînement',
    state: 'Statut',
    successRate: 'Taux de réussite',
  },
  deleteQuestionModal: {
    title: 'Supprimer une question de certification',
    description:
      'Lorsque vous modifiez une certification, cela fausse les résultats de ceux qui l’ont déjà obtenue ou ratée. ',
    checkboxLabel: 'Permettre de repasser la certification à ceux qui y avait répondu.',
    deleteButtonLabel: 'Supprimer',
    cancelButtonLabel: 'Annuler',
  },
  deleteRespondentQuestionModal: {
    title: 'Supprimer le passage de la certification',
    description:
      'Vous êtes sur le point de supprimer le passage de la certification. Le contributeur aura la possibilité de la repasser ultérieurement.',
  },
  respondentsTable: {
    actions: 'Actions',
    date: 'Date de passage',
    respondent: 'Répondant',
    score: 'Score',
    state: 'Statut',
    time: 'Durée de complétion',
    type: 'Type',
  },
  respondentQuestionsTable: {
    id: 'ID Question',
    time: 'Temps de passage',
    score: 'Score',
  },
};

export default fr;
